import React from 'react';
import './style.scss';

function MobileNav(props) {
    return (
        <div className="mobile_nav-container">
            <div  
                className="mobile_nav-item flex-centered"
                onClick={() => props.toggleSelectedTab(true)}
                style={{ color: props.isFirstTabSelected ? '#6a00ff' : 'rgb(49, 71, 132)' }}
            >
                <div style={{ fontSize: '25px' }}><i className="fas fa-rss-square"></i></div>
                <div>Entities</div>
            </div>
            <div 
                className="mobile_nav-item flex-centered"
                onClick={() => props.toggleSelectedTab(false)}
                style={{ color: !props.isFirstTabSelected ? '#6a00ff' : 'rgb(49, 71, 132)' }}
            >
                <div style={{ fontSize: '25px' }}><i className="fas fa-newspaper"></i></div>
                <div>Articles</div>
            </div>
        </div>
    );
}

export default MobileNav;